// extracted by mini-css-extract-plugin
export var closeButton = "_qb-2";
export var closeButtonIcon = "_qb-3";
export var lightboxContent = "_qb-1";
export var lightboxOverlay = "_qb-0";